import React from 'react';
import {connect} from 'react-redux';
import {modal} from 'react-redux-modal';
import { EditProfileFormView, ConfirmCloseModal } from '../';
import { fetchCurrentUser } from '../../actions/currentUser';
import './styles.scss';
import { modalViewGA } from '../../utils/googleAnalytics';

class EditProfile extends React.Component {
  constructor(props) {
    super(props);
    this.cancel = this.cancel.bind(this);
    this.updateFormState = this.updateFormState.bind(this);
    this.formDirty = false;
    this.state = {stateInitialized: false};
  }

  cancel(e) {
    e.preventDefault();
    if(this.formDirty) {
      modal.add(ConfirmCloseModal, { title: '', size: 'medium', hideTitleBar: true, removeParentModal: this.props.closeForm });
    } else {
      this.props.closeForm();
    }
    window.scroll(0, 0);
  }

  componentDidMount() {
    modalViewGA('edit-profile');
  }

  componentWillMount() {
    this.props.dispatch(fetchCurrentUser());
  }

  componentWillUpdate(nextProps) {
    if((!this.props.currentUser && nextProps.currentUser) || (this.props.currentUser && !this.state.stateInitialized)) {
      this.setState({stateInitialized:true});
    }
  }

  updateFormState(isDirty){
    this.formDirty = isDirty;
  }

  render() {
    return (
      <div className="modals-popup edit-profile-modal u-font-foundation-roman">
        <div className="modal-header d-flex align-items-center edit-profile-header">
          <div className="col">Edit Profile Info</div>
          <div className="text-right">
            <a className="closer" href="#" onClick={this.cancel}></a>
          </div>
        </div>
        <div className="info">
          {this.state.stateInitialized &&
          <EditProfileFormView formStatus={this.updateFormState} closeForm={this.props.closeForm} cancel={this.cancel} />
          }
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    currentUser: state.currentUser.data,
    isFetching: state.currentUser.isFetching,
  };
}
export default connect(mapStateToProps)(EditProfile);
